import React, { Component } from 'react';
import './InformationSG.js.css';

export class InformationSG extends Component {
    obtenirNomProvince() {
        const { province } = this.props.serviceGarde;
        let nomProvince;
        switch (province) {
            case 'QC':
                nomProvince = 'Québec';
                break;
            default:
                nomProvince = province;
        }
        return nomProvince;
    }

    formaterCodePostal() {
        const { codePostal } = this.props.serviceGarde;
        console.log(codePostal)
        if (codePostal !== undefined && codePostal.length === 6) {
            return codePostal.slice(0, 3) + ' ' + codePostal.slice(3);
        }
        return codePostal;
    }

    render() {
        const { nom, type, placesPermis, numeroCivique, rue, municipalite } = this.props.serviceGarde;

        return (
            <div className='infoSG'>
                <div>
                    <strong>{nom}</strong> ({type} - {placesPermis} places)
                </div>
                <div>
                    {numeroCivique ? numeroCivique + ', ' : ''} {rue}
                </div>
                <div>
                    {municipalite}, {this.obtenirNomProvince()} {this.formaterCodePostal()}
                </div>
                <hr />
            </div>
        );
    }
}
